import { Controller } from "stimulus"
import consumer from '../channels/consumer'

export default class extends Controller {
  static targets = [ "row", "selectedRowInput" ]
 
  connect() {
    this.highlightSelectedRows();
  }

  disconnect() {
  }

  selectRow(event) {
    event.preventDefault();
    // Find the row to select
    let row = event.target.closest('[data-row-select-id]')
    let ids = this.getSelectedRows()
    ids.push(row.dataset.rowSelectId)
    this.setSelectedRows(ids)
  }

  unselectRow(event) {
    event.preventDefault();
    // Find the row to remove
    let row = event.target.closest('[data-row-select-id]')
    let ids = this.getSelectedRows()
    let index = ids.indexOf(row.dataset.rowSelectId)
    if (index > -1) {
      ids.splice(index, 1)
    }
    this.setSelectedRows(ids)
  }

  getSelectedRows() {
    return this.selectedRowInputTarget.value.split(',').filter(String) // the filter removes the preceeding empty string
  }

  setSelectedRows(arr) {
    // Unique the array before setting the value
    let uniqIds = [...new Set(arr)]
    this.selectedRowInputTarget.value = uniqIds.join(',')
    this.highlightSelectedRows();
  }

  highlightSelectedRows() {
    let selectClass = this.selectedRowClass();
    let selectedIds = this.getSelectedRows();

    this.rowTargets.forEach((row) => {
      if (selectedIds.includes(row.dataset.rowSelectId)) {
        row.classList.add(selectClass)
        row.querySelector('a[data-row-select-select=true]')?.classList?.add('hidden')
        row.querySelector('a[data-row-select-unselect=true]')?.classList?.remove('hidden')
      }
      else {
        row.classList.remove(selectClass)
        row.querySelector('a[data-row-select-select=true]')?.classList?.remove('hidden')
        row.querySelector('a[data-row-select-unselect=true]')?.classList?.add('hidden')
      }
    })
  }

  selectedRowClass() {
    if (this.data.has('selectedRowClass')) {
      return this.data.get('selectedRowClass')
    }
    else {
      return 'bg-primary-50'
    }
  }
}
